import MaintenanceView from './Maintenance.view';

export default MaintenanceView;
